export const AppRoute = {
	ROOT: '/',
	ABOUT: '/about',
	USING_PHJ: '/using-PHJ',
	CREATE_PROFILE: '/create-profile',
	PROFILE: '/profile',
	LOGIN: '/login',
	EDIT_PROFILE: '/edit-profile',
	PETS: '/pets',
	ADD_PET: '/add-pet',
	PET_PROFILE: '/pet-profile',
	EDIT_PET_PROFILE: '/edit-pet-profile',
	DAYS_DEFINITION: '/days-definitions',
	DAYS_SUMMARIZE: '/days-summarize',
	JOURNAL: '/quality-of-life-journal',
	QUALITY_OF_LIFE: '/quality-of-life',
	GOOD_BAD_DAYS: '/good-bad-days',
	TRACK_WEIGHT: '/track-weight',
	TRACK_WEIGHT_SUMMARIZE: '/track-weight-summarize',
	ADD_QUALITY_OF_LIFE: '/add-quality-of-life',
	EDIT_QUALITY_OF_LIFE: '/edit-quality-of-life',
	QUALITY_OF_LIFE_DETAILS: '/quality-of-life-details',
	ADD_FAMILY_CONCERNS: '/add-family-concerns',
	EDIT_FAMILY_CONCERNS: '/edit-family-concerns',
	FAMILY_CONCERNS_DETAILS: '/family-concerns-details',
};

export const PetProfileTab = {
	DASHBOARD: 'dashboard',
	SYMPTOMS: 'symptoms',
	TRACK_WEIGHT: 'track-weight',
	FAVORITE_THINGS: 'favorite-things',
	PHOTO_JOURNAL: 'photo-journal',
	GOOD_OR_BAD_DAYS: 'good-or-bad-days',
	QUALITY_OF_LIFE_JOURNAL: 'quality-of-life-journal',
	FAMILY_CONCERNS: 'family-concerns',
	EXPORT_DATA: 'export-data',
};

export const InnerRoute = {
	GOOD_BAD_DAYS: 'goodBadDays',
};
